module.exports = __webpack_public_path__ + "static/media/bacalhau1545.6415981b.webp";